import { useCallback, useRef } from 'react'

const useScrollToRef = () => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const scrollToRef = useCallback(() => {
    if (scrollRef?.current) {
      const yOffset = -32
      const y =
        scrollRef.current.getBoundingClientRect().top + window.scrollY + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }, [])

  return { scrollRef, scrollToRef }
}

export default useScrollToRef
